import SlideLibrary from './views/slide-library.vue';

export default {
  path: 'slide-library',
  name: 'slide-library',
  component: SlideLibrary,
};
